import { Injectable } from '@angular/core';
import {
  Headers,
  Http,
  Request,
  RequestOptions,
  RequestOptionsArgs,
  Response,
  XHRBackend,
} from '@angular/http';
import { SpinnerService } from '@chevtek/angular-spinners';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/catch';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpService extends Http {
  constructor(
    backend: XHRBackend,
    defaultOptions: RequestOptions,
    private spinnerService: SpinnerService
  ) {
    super(backend, defaultOptions);
  }

  private pendingRequests = 0;

  private showLoading = false;

  private spinnerTimeout;

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    this.turnOnModal();
    return this.intercept(super.request(url, options));
  }

  intercept(observable: Observable<Response>): Observable<Response> {
    return observable
      .do(
        () => {},
        () => {}
      )
      .catch((err) => {
        return Observable.throw(err);
      })
      .finally(() => {
        this.turnOffModal();
      });
  }

  private turnOnModal() {
    this.pendingRequests++;
    if (!this.showLoading) {
      this.showLoading = true;
      this.spinnerTimeout = setTimeout(() => {
        return this.spinnerService.show('slowProcesses');
      }, 700);
    }
    this.showLoading = true;
  }

  private turnOffModal() {
    this.pendingRequests--;
    if (this.pendingRequests <= 0) {
      clearTimeout(this.spinnerTimeout);
      if (this.showLoading) {
        this.spinnerService.hide('slowProcesses');
      }
      this.showLoading = false;
    }
  }

  forceModalOff() {
    // console.log(`Modal pending requests = ${this.pendingRequests}. Forcing off.`);
    this.pendingRequests = 1;
    this.turnOffModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/service/http.service.ts